import { styled } from '@mui/material/styles';

export const TableStyled = styled('table')`
  border-collapse: collapse;
  width: 100%;
  /* table-layout: fixed; */
  /* overflow-wrap: break-word; */

  thead tr {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  tbody tr:nth-of-type(even) {
    td {
      background-color: #fbfbfb;
    }
  }

  tbody tr:hover {
    td {
      transition: background-color 0.2s;
      background-color: #f6f6f6;
    }
  }

  th {
    background: #f6f6f6;
  }
`;

export const ThStyled = styled('th')<{ variant?: 'table' | 'list' }>(
  ({ theme, variant = 'table' }) => ({
    padding: `12px 8px`,
    background: '#F6F6F6',
    fontWeight: 500,
    lineHeight: 1,
    fontSize: theme.typography.body2.fontSize,
    border: '1px solid #E3E3E3',
    borderTop: 'none',
    borderBottom: 'none',
    borderLeft: variant === 'table' ? undefined : 'none',
    borderRight: variant === 'table' ? undefined : 'none',
    '&:first-of-type': {
      borderLeft: 'none',
    },
    '&:last-child': {
      borderRight: 'none',
    },
    '&:hover': {
      backgroundColor: '#E3E3E3',
      cursor: 'pointer',
      div: {
        opacity: 1,
      },
    },
    textAlign: 'left',
    position: 'relative',
    overflow: 'visible',
    textOverflow: 'ellipsis',
  })
);

interface TdStyled {
  variant?: 'table' | 'list';
  componentStyle?: 'td' | 'th';
  component?: 'td' | 'th';
}

export const TdStyled = styled('td')<TdStyled>(({ theme, component = 'td' }) => ({
  padding: `5px 6px`,
  fontSize: component === 'th' ? theme.typography.body2.fontSize : '0.84rem',
  fontWeight: component === 'th' ? 500 : undefined,
  textAlign: 'left',
  backgroundColor: component === 'th' ? '#F6F6F6' : '#FFF',
  borderTop: 'none',
  borderBottom: 'none',
  '&:first-of-type': {
    borderLeft: 'none',
  },
  '&:last-child': {
    borderRight: 'none',
  },
  alignContent: 'start',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  'a': {
    fontSize: theme.typography.body2.fontSize,
  },
}));

export const TBodyStyled = styled('tbody')`
  position: relative;
`;
